export default [
  { label: 'umn-news', title: 'BLOG_MENU_NEWS'},
  { label: 'muzyka', title: 'BLOG_MENU_MUSIC' },
  { label: 'video', title: 'BLOG_MENU_VIDEO' },
  { label: 'afisha', title: 'BLOG_MENU_AFISHA' },
  { label: 'sobytiya', title: 'BLOG_MENU_EVENTS' },
  // { label: 'longread', title: 'BLOG_MENU_VIEWS' }
]
